module.exports = __webpack_public_path__ + "assets/images/USD100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD100.png
// module id = 1452
// module chunks = 1